/* eslint-disable max-len */
const vi = {
  seo: {
    // eslint-disable-next-line max-len
    keywords: 'BiliBili, miễn phí, anime, anime hay, Top Anime, BL, GL, wetv, iqiyi, crunchyroll, Thanh Gươm Diệt Quỷ, Đại chiến Titan, Về chuyện tôi chuyển sinh thành Slime Phần 2, Tóm lại là cực kỳ đáng yêu, Thất nghiệp chuyển sinh: Đến thế giới khác bèn sống hết mình, Thiên quan tứ phúc, cosplay, Việt sub',
  },
  common: {
    more: 'Khác',
    confirm: 'Xác nhận',
    cancel: 'Hủy bỏ',
    home: 'Trang chủ',
    clickToMove: 'Nhấn để vuốt lên xuống'
  },
  follow: {
    follow: 'Theo dõi',
    following: 'Đang theo dõi',
  },
  roomInfo: {
    share: 'Chia sẻ',
    copySucceed: 'Sao chép liên kết trang thành công',
    copyFailed: 'Sao chép liên kết trang thất bại',
    liveClosed: 'Phát trực tiếp chưa bắt đầu',
    viewer: '{count} người đang xem',
  },
  roomVideo: {
    controlBar: {
      play: 'Phát',
      pause: 'Tạm dừng',
      refresh: 'Làm mới',
      refreshSucceed: 'Làm mới thành công',
      refreshFailed: 'Làm mới thất bại',
      refreshing: 'Đang làm mới',
      fullscreen: 'Chế độ toàn màn hình',
      exitFullscreen: 'Thoát toàn màn hình',
      switchQning: 'Đang chuyển sang chất lượng',
      switchQnFailed: 'Chuyển đổi chất lượng thất bại, vui lòng thử lại.',
      switchQnSucceed: 'Đã chuyển sang chất lượng',
    },
  },
  comment: {
    title: 'Danmaku',
    sender_input_placeholder: 'Gửi Danmaku nào ~',
    sended_send: 'Gửi',
    new_messages: 'Làm mới {count} Danmaku',
    login_before_send: 'Đăng nhập để gửi Danmaku thoả thích',
    // eslint-disable-next-line max-len
    default_welcome: 'Chào mừng đến với phòng phát trực tiếp! Chúng tôi luôn luôn khuyến khích nội dung đa dạng và sáng tạo. Đồng thời, chúng tôi sẽ thực hiện các biện pháp cần thiết để ngăn chặn bất kỳ hành vi vi phạm pháp luật, hành vi vi phạm các quy định và đạo đức của quốc gia sở tại, hành vi vi phạm quyền hợp pháp của người khác và bất kỳ nội dung nào có thể ảnh hưởng đến sự an toàn và sức khỏe của cộng đồng. Ngoài ra, các hành vi vi phạm pháp luật có thể được báo cáo cho cơ quan giám sát để xử lý theo các yêu cầu của pháp luật và quy định hiện hành.'
  },
  rank: {
    title: 'Bảng người dùng',
    login: 'Đăng nhập',
    viewRank: ' để xem xếp hạng của mình',
    toContribute: 'Tặng quà Stars để lên lên bảng ngay',
    myScore: 'Điểm cống hiến',
    noData: 'Mau chiếm top bảng ủng hộ Chủ kênh nào!',
  },
  gift: {
    all: 'Tất cả quà tặng',
    topUp: 'Nạp',
    top: 'Thịnh hành',
    starDesc: 'Người dùng có thể mua Stars, đạo cụ đổi bằng Stars có thể giúp Chủ kênh có thu nhập.',
  },

  introduction: {
    title: 'Giới thiệu Phát trực tiếp',
  },
  balance: {
    insufficientTitle: 'Số dư không đủ',
    insufficientContent: 'Số dư Stars không đủ, vui lòng mua thêm',
    buy: 'Mua',
  },
  payment: {
    title: 'Mua Stars',
    balance: 'Tôi Stars',
    next: 'Thanh toán',
    agree: 'Nhấn "Thanh toán" nghĩa là bạn đồng ý với ',
    agreement: 'Thỏa thuận nạp Stars',
    repay: 'Thanh toán lại',
    getPaid: 'Tôi đã mua',
    orderTitle: 'Bạn vui lòng hoàn thành thanh toán ở trang mới mở',
    exchangeRateDesc: 'Số lượng Stars sẽ thay đổi dựa trên biến động tỷ giá và phương thức thanh toán.',
    methodTitle: 'Chọn phương thức thanh toán',
    // eslint-disable-next-line max-len
    orderDesc: 'Trước khi hoàn thành thanh toán vui lòng không đóng cửa sổ trang. Sau khi thanh toán vui lòng nhấn vào nút dưới đây tùy theo tình trạng của bạn.',
    toast_success: 'Nạp thành công',
    toast_fail: 'Nạp thất bại',
    toast_notPay: 'Chưa nạp xong',
    toast_cancel: 'Hủy nạp Stars',
    toast_timeout: 'Quá thời hạn nạp',
  },
  home: {
    live: 'Trực tiếp',
    liveNow: 'Đang phát trực tiếp',
    refresh: 'Làm mới',
    refreshFailed: 'Làm mới thất bại. Vui lòng thử lại.',
    loadMore: 'Đang tải...',
    noMore: 'Không có gì nữa',
    clickToLive: 'Bấm để sống'
  },
  userCard: {
    followers: '{count} Người theo dõi',
    videos: '{count} Video',
    promote: 'Trở thành Quản lý kênh',
    demote: 'Cách chức Quản lý kênh này',
    mute: 'Cấm người dùng này bình luận',
    unmute: 'Bỏ cấm người dùng này',
  },
  modals: {
    muteConfirm: 'Người dùng bị cấm bình luận sẽ không thể gửi Danmaku, xác nhận cấm {username} bình luận?',
    muteSuccess: 'Người dùng này đã bị cấm bình luận.',
    unmuteConfirm: 'Xác nhận bỏ cấm {username} bình luận?',
    unmuteSuccess: 'Bỏ cấm thành công.',
    promoteConfirm: 'Sẽ mời {username} trở thành Quản lý kênh của bạn, xác nhận trao quyền?',
    promoteSuccess: '{username} đã được Chủ kênh trao quyền làm Quản lý kênh.',
    demoteConfirm: 'Người dùng {username} sẽ không còn là Quản lý kênh của bạn nữa, xác nhận cách chức?',
    demoteSuccess: 'Cách chức thành công.',
  },
  chargeStrip: {
    tabProgress: 'Total Charging',
    consumeStar: 'Dùng Star hoặc làm nhiệm vụ để nhận năng lượng tham gia quay thưởng.',
    consumeReward: 'Khi dùng 1 Star trong kênh phát trực tiếp, có thể tăng 1 Năng lượng trên thanh năng lượng của kênh và thanh tổng năng lượng.',
    followRoom: 'Theo dõi kênh',
    followRoomAward: 'Tăng 3 Năng lượng vào thanh năng lượng của kênh đã theo dõi và thanh tổng năng lượng.',
    sendDanmaku: 'Gửi 1 Danmaku ở kênh phát trực tiếp hôm nay',
    sendDanmakuAward: 'Tăng 1 Năng lượng vào thanh năng lượng của kênh và thanh tổng năng lượng.',
    watchLive10M: 'Xem một kênh phát trực tiếp 10 phút',
    watchLive10MAward: 'Tăng 1 Năng lượng vào thanh năng lượng của kênh đã xem và thanh tổng năng lượng.',
    watchLive30M: 'Xem một kênh phát trực tiếp 30 phút',
    watchLive30MAward: 'Tăng 3 Năng lượng vào thanh năng lượng của kênh đã xem và thanh tổng năng lượng.',
    watchLive120M: 'Xem một kênh phát trực tiếp 120 phút',
    watchLive120MAward: 'Tăng 15 Năng lượng vào thanh năng lượng của kênh đã xem và thanh tổng năng lượng.',
    watchLive: 'Xem một kênh phát trực tiếp 10/30/120 phút',
    watchLiveAward: 'Tăng 1/3/15 Năng lượng vào thanh năng lượng của kênh đã xem và thanh tổng năng lượng.',

    tabTask: 'Charging Tasks',
    uAddRoomEnergy: 'Năng lượng tích lũy ở kênh phát trực tiếp này hiện là:',
    uAddStationEnerygy: 'Tổng năng lượng tích lũy của bạn là:',
    consumeStarInRoom: 'Khi dùng 1 Star trong kênh phát trực tiếp, có thể tăng 1 Năng lượng trên thanh năng lượng của kênh này và thanh tổng năng lượng.',

    tabRule: 'Rules',
    ruleDesc: 'Dùng Star hoặc làm nhiệm vụ với mỗi cấp bậc thanh năng lượng tương ứng, sau khi tích đầy thanh năng lượng sẽ có thể tham gia quay thưởng ở cấp bậc tương ứng. Chi tiết về phần thưởng vui lòng xem tại "Lịch sử thưởng" ở góc trên bên phải.',
    prizesBoth: 'Phần thưởng tương ứng của thanh năng lượng kênh và thanh tổng năng lượng:',
    prizeRoom: 'Thanh năng lượng kênh',
    prizeStation: 'Thanh tổng năng lượng',
    avatarFrames: 'Khung ảnh đại diện',
    premium: 'Premium',
    winningRecords: 'Lịch sử thưởng'
  },
  blindBoxAward: {
    title: 'Lịch sử thưởng',
    stars: 'Phần thưởng (Star)',
    send: 'Tặng',
    andWon: 'và mở ra',
    to: 'Tặng',
    noReward: 'Không có lịch sử thưởng',
  }
};

export default vi;
